'use strict';

var smallBreakpoint = 320;
var mediumBreakpoint = 480;
var largeBreakpoint = 768;
var desktopBreakpoint = 1024;
var maxBreakpoint = 1280;

var homePageUtils = {
    /**
     * @desc Media breakpoints that are used throughout the Javascript
     */
    breakpoints: {
        xs: smallBreakpoint,
        sm: mediumBreakpoint,
        md: largeBreakpoint,
        lg: desktopBreakpoint,
        xl: maxBreakpoint,
        'mobile-menu': desktopBreakpoint
    },

    /**
     * @function
     * @description Returns either an object with all of the available breakpoints or a specific viewport based on the given size
     * @param {string} size The viewport to return
     * @param {string} breakpoints A custom breakpoints object
     * @returns {Object|string} - breakpoints or specific viewport
     */
    getViewports: function (size, breakpoints) {
        var bps = typeof breakpoints !== 'undefined' ? breakpoints : this.breakpoints;

        if (typeof size !== 'undefined') {
            var viewport = bps[size];

            if (viewport) {
                return viewport;
            }

            window.console.error('Unexpected viewport size given in util.getViewports');
            throw new Error('Unexpected viewport size given in util.getViewports');
        } else {
            return breakpoints;
        }
    },

    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {string} qs The query string from which the parameters will be extracted
     * @returns {Object} - Object with params from the query string
     */
    getQueryStringParams: function (qs) {
        if (!qs || qs.length === 0) { return {}; }
        var params = {};
        var unescapedQS = decodeURIComponent(qs);
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
            function ($0, $1, $2, $3) {
                params[$1] = $3;
            }
        );
        return params;
    },

    /**
     * @function
     * @description extract the query string from URL
     * @param {string} url the url to extra query string from
     * @returns {string|Object} - Query String from URL
     **/
    getQueryString: function (url) {
        var qs;
        if (!typeof url === 'string') {
            return null;
        }
        var a = document.createElement('a');
        a.href = url;
        if (a.search) {
            qs = a.search.substr(1); // remove the leading ?
        }
        return qs;
    },

    /**
     * @function
     * @desc Generates a min-width matchMedia media query based on the given params
     * @param {string} size - Breakpoint to use for the media query
     * @param {Object} breakpoints - Override of the util breakpoints (optional)
     * @returns {boolean} - Wether or not the given media query matches
     */
    mediaBreakpointUp: function (size, breakpoints) {
        var breakpoint = this.getViewports(size, breakpoints);
        var mediaQuery = window.matchMedia('(min-width: ' + breakpoint + 'px)');
        return mediaQuery.matches;
    },

    /**
     * @function
     * @description appends the parameter with the given name and value to the given url and returns the changed url
     * @param {string} url the url to which the parameter will be added
     * @param {string} name the name of the parameter
     * @param {string} value the value of the parameter
     * @returns {string} - URL with parameter
     */
    appendParamToURL: function (url, name, value) {
        // quit if the param already exists
        if (url.indexOf(name + '=') !== -1) {
            return url;
        }
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        return url + separator + name + '=' + encodeURIComponent(value);
    },

    /**
     * @function
     * @desc Retrieves the next key in the object or null if it doesn't exist
     * @param {Object} obj - Object to get the next key from
     * @param {string} key - Key to base the next key index on
     * @returns {string}|{null} - The next key of the given object or null if one doesn't exist
     */
    getNextObjectKey: function (obj, key) {
        var keys = Object.keys(obj);
        var nextIndex = keys.indexOf(key) + 1;

        if (keys.length > nextIndex) {
            return keys[nextIndex];
        }

        return null;
    },

    /**
     * @function
     * @desc Generates a min-width matchMedia media query based on the given params
     * @param {string} size - Breakpoint to use for the media query
     * @param {Object} breakpoints - Override of the util breakpoints object (optional)
     * @returns {boolean} - Wether or not the given media query matches
     */
    mediaBreakpointDown: function (size, breakpoints) {
        var bps = typeof breakpoints !== 'undefined' ? breakpoints : this.breakpoints;
        var nextSize = this.getNextObjectKey(bps, size);

        if (typeof nextSize === 'string') {
            var breakpoint = this.getViewports(nextSize, breakpoints) - 1;
            var mediaQuery = window.matchMedia('(max-width: ' + breakpoint + 'px)');
            return mediaQuery.matches;
        }

        return true;
    },

    /**
     *  calculate amplience carousel height
     */
    imageHeightToSetArrow: function () {
        var $components = $('.amplience-carousel .carousel-container');
        $components.each(function () {
            var $carouselImage = $(this).find('.product.grid-tile:nth-child(1) .image-container img');
            var currHeight = $carouselImage.height();
            var arrowHeightbyHalf = 40;
            var arrowPosition = (currHeight / 2) - arrowHeightbyHalf;
            if (arrowPosition > 0) {
                $(this).find('.slick-next').css('top', arrowPosition);
                $(this).find('.slick-prev').css('top', arrowPosition);
            }
        });
    },

    homePageRedesign: {
        carouselDefaultSettings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            centerPadding: '40px',
            arrows: true,
            dots: true,
            infinite: false,
            rows: 0
        },
        orderHistorySettings: {
            dots: false,
            arrows: false,
            vertical: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            verticalSwiping: true,
            setPosition: true,
            rows: 0
        },
        heroCarouselRedesign: {
            autoplay: true,
            autoplaySpeed: 5000,
            easing: 'swing',
            infinite: true,
            speed: 800,
            dots: false,
            arrows: true,
            centerMode: false,
            centerPadding: '0',
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: false,
                        rows: 0
                    }
                }
            ]
        },
        heroCarouselE2E: {
            autoplay: true,
            autoplaySpeed: 5000,
            easing: 'swing',
            infinite: true,
            speed: 800,
            dots: true,
            arrows: false,
            centerMode: false,
            centerPadding: '0',
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0
        }
    },
    recommendedProductsRedesignATC: {
        slidesToShow: 4,
        slidesToScroll: 1,
        centerPadding: '40px',
        arrows: true,
        infinite: false,
        rows: 0,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    rows: 0
                }
            }
        ]
    }
};

module.exports = homePageUtils;
